import localStorageKeys from './localStorageKeys'
import localStorageManager from './localStorageManager'

export const getFieldForSorting = (item, fields, customFieldLogic) => {
    const field = fields.find(field => item[field] !== '' && item[field] !== null)
    const customLogic = customFieldLogic?.[field]
    if (customLogic) {
        return customLogic(item)
    }
    return item[field] ?? null
}

export const sortBySelected = (selectedData, sortId, sortingOptions, customFieldLogic = null) => {
    let sortedData = selectedData?.length > 0 ?  [...selectedData] : []
    const selectedSortOption = localStorageManager.get(localStorageKeys.SORT_OPTIONS)?.[sortId]
    const selectedItem = sortingOptions?.find(({sorting}) => sorting && Object.values(sorting)?.some(item => item?.key === selectedSortOption))

    if (!selectedItem) {
        return sortedData
    }
    const {asc, desc} = selectedItem.sorting
    const sortingOption = asc?.key === selectedSortOption ? asc :  desc
    const comparison = asc?.key === selectedSortOption ? 1 : -1

    const getFieldValue = (value) => Array.isArray(value) ? (value.length > 0 ? value[0] : '') : value

    return sortedData.sort((a, b) => {
        const aValue = getFieldValue(getFieldForSorting(a, sortingOption.field, customFieldLogic))
        const bValue = getFieldValue(getFieldForSorting(b, sortingOption.field, customFieldLogic))

        if (typeof aValue === 'number' && typeof bValue === 'number') {
            return comparison * (aValue - bValue)
        }
        return comparison * aValue?.toLowerCase().localeCompare(bValue?.toLowerCase())
    })
}
